// initial state
const state = () => ({
  preferences: [],
});

// getters
const getters = {
  getPreferences: state => {
    return state.preferences;
  },
};

// actions
const actions = {
  load({ commit, getters }) {
    if (getters.getPreferences.length > 0) {
      return Promise.resolve();
    }

    return axios
      .get(zRoute('ajax.preferences.index'))
      .then(function (response) {
        commit('setPreferences', response.data.data);
      }, function (error) {
        //
      });
  },
};

// mutations
const mutations = {
  setPreferences: (state, preferences) => {
    state.preferences = preferences;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
